<div class="container">
    <div class="col-12 my-3">
        <div class="d-flex justify-content-between">
            <span class="subtitle m-1" i18n="annex@@pictures_out">Photos extérieur</span>
            <button type="button" class="btn btn-lg primary longSubmit col-md-6 m-1" i18n="newTchek|@@addNewTchek"
            (click)="openmodalExterior()">Ajouter une Image</button> 
        </div>
      <div class="d-flex flex-column pt-4">
          <div id="imageContainer" class="row container-fluid "
          *ngIf="insideClassificationImage !== true && currentMode === 'image' && tchekExterior && tchekExterior.images && tchekExterior.images.length > 0">
          <div class="col-12">  
            <ul #picture class="containerScroll d-flex">
              <li *ngFor="let image of tchekExterior.images" class="imageBlock">
                  <div class="d-flex flex-row py-4 mx-2">
                    <img [ngClass]="{'isDeleted ' : image.isDeleted}" style="z-index: 11;" class='Image 'src='{{image.file.url()}}' (click)='switchToImage(image)' (load)="picture.classList.remove('d-none')" crossorigin="anonymous" /> 
                    <img style="z-index: 12;" class='icon ' src="../../../assets/icon/remove.svg" (click)="deleteImage(image)"/> 
                  </div>
              </li>
            </ul>
          </div>
        </div> 
      </div>
  
      <ng-template #contentExterior>
      <div class="modal-body">
          <div class="container">
              <div class="row">
                  <div class="col-12">
                      <img src="../../../assets/icon/close-modal.svg" class="close" aria-label="Close"
                          (click)="modalRef.dismiss('Cross click')" />
                  </div>
              </div>
  
              <div class="row">
                  <div class="col-9">
                      <div class="line">
                          <div class="custom-dropzone detection-dropzone" ngx-dropzone [accept]="'image/*'"
                              (change)="onSelect($event)" [disabled]='saving'>
                              <ngx-dropzone-label class="dropzone-label">
                                  <div class="row p-0 m-0 justify-content-md-center">
                                      <p i18n="new-tchek|@@downloadImageButton" class="h5 font-weight-bold">Télécharger une image</p>
                                  </div>
                                  <div class="row  p-0 m-0 justify-content-md-center">
                                      <div class="col-12 col-md-6">
                                          <p i18n="new-tchek|@@dragFile" class="smallText dark">ou déposer un fichier.</p>
                                      </div>
                                  </div>
  
                              </ngx-dropzone-label>
                              <ngx-dropzone-image-preview ngProjectAs=" ngx-dropzone-preview" class="fileContainer"
                                  *ngFor="let f of files" [file]="f" [removable]="true" (removed)="onRemove(f)">
                                  <!-- <ngx-dropzone-label>{{ f.name }}</ngx-dropzone-label> -->
                              </ngx-dropzone-image-preview>
                          </div>
  
                      </div>
                  </div>
              </div>
          </div>
      </div>
      <div class="modal-footer" *ngIf="saving !== true">
          <button type="button" class="btn btn-lg primary" i18n="modal_classification|@@cancel"
              (click)="modalRef.dismiss('Cross click')">Annuler</button>
          <button type="button" class="btn btn-lg primary" i18n="modal_classification|@@save"
              (click)="saveTchekExterior()"
              *ngIf="this.files && this.files.length > 0">Valider</button>
      </div>
      <div class="modal-footer" *ngIf="saving === true">
          <button type="button" class="btn btn-lg primary" i18n="modal_classification|@@validate"
              *ngIf="this.files && this.files.length > 0">
              <img src="../../../assets/images/spinner.gif" alt="" style="width: 30; height: 30px;"> Valider</button>
      </div>
      </ng-template>
    </div>
    <div class="col-12 my-3">
        <div class="d-flex justify-content-between">
            <span class="subtitle m-1" i18n="annex@@pictures_in">Photos intérieur</span>
            <button type="button" class="btn btn-lg primary longSubmit col-md-6 m-1" i18n="newTchek|@@addNewTchek"
            (click)="openmodalInterior()">Ajouter une Image</button>

        </div>
      <div class="d-flex flex-column pt-4">
        <div id="imageContainer" class="row container-fluid "
        *ngIf="insideClassificationImage !== true && currentMode === 'image' && tchekInterior && tchekInterior.images && tchekInterior.images.length > 0">
        <div class="col-12">
          <ul #pictureInterior class="containerScroll d-flex ">
            <li *ngFor="let image of tchekInterior.images" class="imageBlock">
                <div class="d-flex flex-row py-4 mx-2">
                    <img [ngClass]="{
                    'isDeleted ' : image.isDeleted}" style="z-index: 11;" class='Image'
                      src='{{image.file.url()}}' (load)="pictureInterior.classList.remove('d-none')" crossorigin="anonymous" />
                    <img style="z-index: 12;" class='icon ' src="../../../assets/icon/remove.svg" (click)="deleteImage(image)"/>
                </div>
            </li>
          </ul>
        </div>
      </div> 
    </div>
      <ng-template #contentInterior>
        <div class="modal-body">
            <div class="container">
                <div class="row">
                    <div class="col-12">
                        <img src="../../../assets/icon/close-modal.svg" class="close" aria-label="Close"
                            (click)="modalRef.dismiss('Cross click')" />
                    </div>
                </div>
                <div class="row">
                    <div class="col-9">
                        <div class="line">
                            <div class="custom-dropzone detection-dropzone" ngx-dropzone [accept]="'image/*'"
                                (change)="onSelect($event)" [disabled]='saving'>
                                <ngx-dropzone-label class="dropzone-label">
                                    <div class="row p-0 m-0 justify-content-md-center">
                                        <p i18n="new-tchek|@@downloadImageButton" class="h5 font-weight-bold">Télécharger une image</p>
                                    </div>
                                    <div class="row  p-0 m-0 justify-content-md-center">
                                        <div class="col-12 col-md-6">
                                            <p i18n="new-tchek|@@dragFile" class="smallText dark">ou déposer un fichier.</p>
                                        </div>
                                    </div>
    
                                </ngx-dropzone-label>
                                <ngx-dropzone-image-preview ngProjectAs=" ngx-dropzone-preview" class="fileContainer"
                                    *ngFor="let f of files" [file]="f" [removable]="true" (removed)="onRemove(f)">
                                    <!-- <ngx-dropzone-label>{{ f.name }}</ngx-dropzone-label> -->
                                </ngx-dropzone-image-preview>
                            </div>
    
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="modal-footer" *ngIf="saving !== true">
            <button type="button" class="btn btn-lg primary" i18n="modal_classification|@@cancel"
                (click)="modalRef.dismiss('Cross click')">Annuler</button>
            <button type="button" class="btn btn-lg primary" i18n="modal_classification|@@save"
                (click)="saveTchekInterior()"
                *ngIf="this.files && this.files.length > 0">Valider</button>
        </div>
        <div class="modal-footer" *ngIf="saving === true">
            <button type="button" class="btn btn-lg primary" i18n="modal_classification|@@validate"
                *ngIf="this.files && this.files.length > 0">
                <img src="../../../assets/images/spinner.gif" alt="" style="width: 30; height: 30px;"> Valider</button>
        </div>
        </ng-template>
    </div>
  </div>
  


// WEBPACK FOOTER //
// ./src/app/element/annex-picture/annex-picture.component.html